<template>
  <div class="books">
    <div class="tag">
      <div class="tag-item" v-for="item in tagList" :class="{active: item.id == tagId}" @click="tagChange(item.id)">{{item.label}}</div>
    </div>
    <div class="book-list">
      <div class="book-item hvr-grow" v-for="(item,i) in goodsList" @click="goDetail(item)" v-if="i < 6">
        <img :src="item.cover" alt="" width="216" height="315">
        <div class="goods-title">{{item.goodsTitle}}</div>
      </div>
      <div v-if="goodsList.length == 0" style="text-align: center;width: 100%;color: #aaa;">暂无书籍</div>
    </div>
    <div class="book-link">
      <div class="link hvr-round-corners hvr-shadow" v-for="item in linkList" >
        <a :href="item.linkAddress" target="_Blank"><img :src="item.coverPath" alt="" width="100%" height="100%" >  </a>
      </div>
    </div>
  </div>
</template>

<script>
import  { getCatalogList,getResourceList } from "@/api/index/index.js";

export default {
  name: "bookSuggest",
  props: ['id','id2'],
  data(){
    return{
      tagList:[],
      tagId: 0,
      goodsList:[],
      linkList:[]
    }
  },
  mounted() {
    getCatalogList({featuredId: this.id}).then(res=>{
      this.tagList = res.data
      this.tagChange(this.tagList[0].id)
    })
    getResourceList({featuredId: this.id2}).then(res=>{
      this.linkList = res.data
    })
  },
  methods:{
    tagChange(id){
      this.tagId = id
      getResourceList({featuredId: this.id,catalogId: this.tagId}).then(res=>{
        this.goodsList = res.data
      })
    },
    goDetail(item){
      if(item.goodsType == 'train'){
        this.$router.push({
          path: "/willingLearn/bookstoreDetail",
          query: {
            goodsId: item.goodsId,
            goodsType: item.goodsType,
          },
        });
      }else{
        this.$router.push({
          path: "/bookstore/bookstoreDetail",
          query: {
            goodsId: item.goodsId,
            goodsType: item.goodsType,
          },
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .books{
    width: 1400px;
    margin: 0 auto;
    .tag{
      display: flex;
      margin: 30px 0 48px;
      .tag-item{
        font-size: 24px;
        cursor: pointer;
        color: #6d6d6d;
        line-height: 1;
        margin-right: 32px;
        &.active{
          color: #128bff;
        }
      }
    }
    .book-list{
      display: flex;
      width: 1400px;
      .book-item{
        position: relative;
        margin-left: 19px;
        cursor: pointer;
        &:first-of-type{
          margin-left: 0;
        }
        .goods-title{
          display: none;
          position: absolute;
          bottom: 0;
          text-align: center;
          background-color: rgba(0,0,0,.6);
          width: 100%;
          padding: 5px 0;
          color: #fff;
        }
        &:hover{
          .goods-title{
            display: block;
          }
        }
      }
    }
    .book-link{
      display: flex;
      width: 1400px;
      margin-top: 47px;
      justify-content: space-between;
      .link{
        width: 694px;
        height: 194px;
        border: 1px solid #ddd;
        overflow: hidden;
      }
    }
  }
</style>